import { render, staticRenderFns } from "./ClassTimeTable.vue?vue&type=template&id=d270ddba&scoped=true"
import script from "./ClassTimeTable.vue?vue&type=script&lang=js"
export * from "./ClassTimeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d270ddba",
  null
  
)

export default component.exports